import {
  Loading,
  ShowContextProvider,
  useShowController,
  // ReferenceField,
  // TextField,
  useTranslate,
  useLocaleState,
} from 'react-admin'
import { CSRAuthor } from '../../components/domains/csr/CSRAuthor'
import { CSRTitle } from '../../components/domains/csr/CSRTitle'
import { CSRImgHeader } from '../../components/domains/csr/CSRImgHeader'
import { CSRContent } from '../../components/domains/csr/CSRContent'
// import CSRAttachment from '../../components/domains/csr/CSRAttachment'
import CSRImages from '../../components/domains/csr/CSRImages'
import {
  Card,
  Container,
  Stack,
  styled,
  // Table,
  // TableBody,
  // TableCell,
  // TableContainer,
  // TableHead,
  // TableRow,
  Box,
  Typography,
  TypographyProps,
  Paper,
} from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import ModifyTimeStamp from '../../components/ModifyTimeStamp'
import { ListActions } from '../../components/list-actions'
import { CSR_FIELDS } from '../../providers/localization/constant'
import { ImageField } from '../../components/fields'

const StackStyled = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(4, 5),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 10),
  },
}))

const Heading: React.FC<TypographyProps> = ({ children, ...props }) => {
  return (
    <Typography variant='subtitle2' sx={{ color: '#ADB3BD', fontWeight: 'normal' }} {...props}>
      {children}
    </Typography>
  )
}

const PreviewThumbnail = styled(ImageField)(() => ({
  '& .RaImageField-image': {
    width: '100%',
    height: 300,
    objectFit: 'cover',
    objectPosition: '50% 50%',
    borderRadius: 5,
  },
}))

const PaperStyled = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: 300,
  width: '100%',
  lineHeight: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .RaImageField-image': {
    verticalAlign: 'middle',
  },
}))

const ContentWrapper = styled(Box)(() => ({ display: 'block', mb: 3 }))

export const CSRShow: React.FC = () => {
  const [locale] = useLocaleState()
  const langActive = locale
  const showController = useShowController()
  const { isLoading, record } = showController
  const translate = useTranslate()
  if (isLoading) return <Loading />

  return (
    <ShowContextProvider value={showController}>
      <Container maxWidth='md'>
        <ListActions
          hasCreate={false}
          hasExport={false}
          hasList={true}
          hasPreview={true}
          hasEdit={true}
        />
        <Card>
          <CSRImgHeader source='cover.full_path' />
          <StackStyled spacing={1}>
            <ModifyTimeStamp />
            <CSRTitle source={`title_${langActive}`} />
            <Stack direction='row' alignItems='center' spacing={0.5}>
              <CSRAuthor authorSource='create_by' dateSource='create_at' />
              {record.all_views ? (
                <>
                  <VisibilityIcon color='disabled' sx={{ fontSize: 18 }} />
                  <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                    {record.all_views}
                  </Typography>
                </>
              ) : null}
            </Stack>
            <ContentWrapper>
              <Heading>
                {translate(`${CSR_FIELDS}.short_description`)}
                <CSRContent source={`short_description_${langActive}`} />
              </Heading>
            </ContentWrapper>
            <ContentWrapper>
              <Heading>
                {translate(`${CSR_FIELDS}.description`)}
                <CSRContent source={`description_${langActive}`} />
              </Heading>
            </ContentWrapper>
            <ContentWrapper>
              <Heading>
                {translate(`${CSR_FIELDS}.thumbnail`)}
              </Heading>
              {record.thumbnail ? (
                    <PreviewThumbnail source='thumbnail.full_path' />
                  ) : (
                    <PaperStyled variant='outlined'>
                      <Typography variant='caption' sx={{ color: 'error.main' }}>
                        {translate(`${CSR_FIELDS}.thumbnail.notfound`)}
                      </Typography>
                    </PaperStyled>
                  )}
            </ContentWrapper>
            <ContentWrapper>
            <CSRImages source='images' title='name' />
            </ContentWrapper>
            {/* <CSRAttachment source='files.full_path' title='name' /> */}
          </StackStyled>
        </Card>
        {/* <br />
          {record.views && record.views.length !== 0 ? (
            <TableContainer component={Card}>
              <Table sx={{ minWidth: 650 }} aria-label='views table'>
                <TableHead>
                  <TableRow>
                    <TableCell>{translate('resources.CSR.viewer.from')}</TableCell>
                    <TableCell align='right'>{translate('resources.CSR.viewer.views')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {record.views.map((item, id) =>
                    item.property_id == 'guest' ? (
                      <TableRow key={id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component='th' scope='row'>
                          {translate('resources.CSR.viewer.guest')}
                        </TableCell>
                        <TableCell align='right'>{item.views}</TableCell>
                      </TableRow>
                    ) : (
                      <TableRow key={id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component='th' scope='row'>
                          <ReferenceField
                            source={'views[' + id + '].property_id'}
                            reference='properties'
                            link={false}
                          >
                            <>
                              <TextField source='project_code' />-
                              <TextField source={translate('resources.CSR.viewer.project')} />
                            </>
                          </ReferenceField>
                        </TableCell>
                        <TableCell align='right'>{item.views}</TableCell>
                      </TableRow>
                    ),
                  )}
                  <TableRow key='all' sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell component='th' scope='row'>
                      <b>{translate('resources.CSR.viewer.all_views')}</b>
                    </TableCell>
                    <TableCell align='right'>{record.all_views ? record.all_views : 0}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : null} */}
      </Container>
    </ShowContextProvider>
  )
}

export default CSRShow